//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import makeAngularReactController from '@react-bridge/angular-react-widget';
import AutoConfigTbb from '@streams/components/AutoActiveConfigRules';

angular.module('curalate').component('autoConfigTbb', {
  controller: makeAngularReactController(<AutoConfigTbb />),
});
